import Common from '../../Common';
import IVR from './profile/IVR';
import Schedule from './profile/Schedule';
import Soundfile from './profile/Soundfile';

interface Search {
	limit?: number,
	limit_from?: number,
	search?: string,
	order_by?: string,
	order_dir?: string,
}

const Profile = class extends Common {
	schedule: InstanceType<typeof Schedule>;
	ivr: InstanceType<typeof IVR>;
	soundfile: InstanceType<typeof Soundfile>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.schedule = new Schedule(headers);
		this.ivr = new IVR(headers);
		this.soundfile = new Soundfile(headers);
	}

	read = (userId: id, profileId: id) =>
		this.get(`/user/${userId}/profile/${profileId}`)

	browse = (userId: id, search: Search = { limit: 1000 }): CustomResponse<BrowseResponse & { profiles: Profile[] }> =>
		this.get(`/user/${userId}/profiles`, search)

	activate = (userId: id, profileId: id) =>
		this.post(`/user/${userId}/profile/${profileId}`)
}

export default Profile;
